export const NAME = 'purchase';

export const PAYMENT_PROVIDER = 'stripe';
